import { Accounts } from './domain/account/account';
import { Identity } from './domain/identity';
import { Leaderboard } from './domain/leaderboard/leaderboard';
import { TradeEvents } from './domain/trade-events/trade-events';
import { UI, TradeEvents as UITradeEvents } from './domain/ui/ui';
import { RootStore } from './root-store';

export const defaultStore = new RootStore({
  leaderboard: new Leaderboard({ followedTraders: [] }),
  tradeEvents: new TradeEvents({
    events: [],
    count: 0,
  }),
  identity: new Identity({ }),
  accounts: new Accounts({ }),
  ui: new UI({
    tradeEvents: new UITradeEvents({
      skip: 0,
      take: 10,
    }),
  }),
});
